/**
 * 💀 **How a killed sheep lies — D125.** 🎯 haugur: *"falls over, meat to
 * pack."*
 *
 * 🔴 **One function, used by the field AND by `rigsheet.html`**, so the picture
 * that gets baked for him is the fall the game draws — not a second copy of it
 * that drifts. ⚠️ *A second way in forgets what the first one does*, six times
 * in this repo.
 *
 * **The whole body rolls onto its side about its own length.** No new pose in
 * the rig: a dead sheep's legs are stiff, and a tipped body with straight legs
 * is what that looks like.
 */

/** 💀 How long a killed sheep takes to tip onto its side, seconds. */
export const TIP_SECONDS = 0.5;

/**
 * 💀 **How far a sheep lying on its side is lifted, metres** — half the width
 * of its body (0.42 m across), so its flank rests ON the ground rather than
 * half under it. ⚠️ A dial, checked by baking the picture.
 */
export const LYING_LIFT = 0.21;

/**
 * 💀 **The roll and the lift for a sheep `fallen` of the way over**, 0 → 1.
 *
 * ⚠️ **Eased with a sine**, so it tips slowly at first and lands — a linear roll
 * reads as a door swinging shut.
 *
 * 🔴 **Apply the roll with Euler order `YXZ`**, yaw first and then the roll
 * about the body's own long axis. three.js's default `XYZ` rolls in the WORLD's
 * frame, and a sheep facing north would fall onto its nose.
 */
export function lyingPose(fallen: number): { roll: number; lift: number } {
  const f = Math.max(0, Math.min(1, fallen));
  const tipped = Math.sin((f * Math.PI) / 2);
  return { roll: tipped * (Math.PI / 2), lift: tipped * LYING_LIFT };
}
